import { authRoutes } from '@/features/auth/authRoutes.js'
import { authGuard } from '@/features/auth/guards/authGuard.js'
import { sessionGuard } from '@/features/auth/guards/sessionGuard.js'
import { tenantTokenGuard } from '@/features/auth/guards/tenantTokenGuard.js'
import { clubLandingRoutes } from '@/features/clubLanding/clubLandingRoutes.js'
import { dashboardRoutes } from '@/features/dashboard/dashboardRoutes.js'
import { eventManagementRoutes } from '@/features/eventManagement/eventManagementRoutes.js'
import { resolveAdminRootRedirect } from '@/features/layout/components/constants/adminSidebarPermissionNavigation.js'
import DashboardLayout from '@/features/layout/DashboardLayout.vue'
import { mailerRoutes } from '@/features/mailer/mailerRoutes.js'
import { memRegRoutes } from '@/features/memReg/memRegRoutes.js'
import { notificationManagementRouter } from '@/features/notificationManagement/notificationManagementRouter.js'
import { peopleManagementRouter } from '@/features/peopleManagement/peopleManagementRouter.js'
import { profileManagementRoutes } from '@/features/profileManagement/profileManagementRoutes.js'
import { clubRegisteredGuard } from '@/features/router/guards/clubRegisteredGuard.js'
import { mobileAppManagementRouter } from '@/features/settingsManagement/mobileAppManagement/mobileAppManagementRouter.js'
import { settingsManagementRoutes } from '@/features/settingsManagement/settingsManagementRoutes.js'
import { siteRoutes } from '@/features/site/siteRoutes.js'
import { tenantCodesRoutes } from '@/features/superAdmin/tenantCodes/tenantCodesRoutes.js'
import { tenantGroupsRoutes } from '@/features/superAdmin/tenantGroups/tenantGroupsRoutes.js'
import { tenantTermGroupsRoutes } from '@/features/superAdmin/tenantTermGroups/tenantTermGroupsRoutes.js'
import { tenantTermsRoutes } from '@/features/superAdmin/tenantTerms/tenantTermsRoutes.js'
import { trackingRoutes } from '@/features/tracking/trackingRoutes.js'
import NotFoundView from '@/features/views/NotFound/NotFoundView.vue'

import { adminGuard } from './guards/adminGuard'

export const clubRoutes = [
  ...clubLandingRoutes,
  {
    path: 'admin',
    beforeEnter: [authGuard, sessionGuard, clubRegisteredGuard, tenantTokenGuard, adminGuard],
    component: DashboardLayout,
    children: [
      {
        path: '',
        beforeEnter: resolveAdminRootRedirect,
        component: NotFoundView,
      },
      {
        path: 'no-access',
        component: () => import('@/features/noAccess/NoAccessView.vue'),
      },
      ...dashboardRoutes,
      ...eventManagementRoutes,
      ...settingsManagementRoutes,
      ...profileManagementRoutes,
      ...peopleManagementRouter,
      ...trackingRoutes,
      ...mailerRoutes,
      ...notificationManagementRouter,
      ...siteRoutes,
      ...tenantCodesRoutes,
      ...tenantGroupsRoutes,
      ...tenantTermsRoutes,
      ...tenantTermGroupsRoutes,
      ...mobileAppManagementRouter,

      {
        path: ':pathMatch(.*)*',
        name: 'club-not-found',
        component: NotFoundView,
      },
    ],
  },
  ...authRoutes,
  ...memRegRoutes,
]
